module.exports = "/_next/static/images/bb37ef5fd5034ae6b7c617a3df3f571c-phone-and-card@xs-1x.jpg";